<div class="animate-fade-in tw-duration-[1000ms]">
  <kendo-loader class="tw-m-3 tw-text-base-text/[.65]" type="pulsing" size="small"></kendo-loader>
</div>
